import React, { useState } from "react";
import { toast } from "react-toastify";
import metadata from "../../../../common/metadata.json";
import SettingsPanel from "../../components/SettingsPanel";
import { tokenRenew } from "../../../../helpers/fakebackend_helper";

export default function Debug() {
  const { buildMajor, buildMinor, buildRevision, buildTag, buildDate } =
    metadata;
  const version = `${buildMajor}.${buildMinor}.${buildRevision} `;
  const localStorageInfo = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.User_Email;

  const [refreshing, setRefreshing] = useState(false);

  // Task 24685 - "Refresh my session", and why the old button was not it.
  //
  // authUser in localStorage is a snapshot taken at login. Gate.js gates every
  // screen on authUser.get_securityauthcapability_list, and the sidebar is
  // built from authUser.get_staff_data.MenuNav_Id. localStorage survives an F5,
  // so the old button here - whose entire body was window.location.reload() -
  // re-read exactly the same stale snapshot. It was the most reassuring way
  // possible of doing nothing, on the one screen somebody would come to
  // looking for this.
  //
  // This asks the server for a fresh token, which now returns both of those
  // blocks (AuthTokenRenewController), writes them into authUser and only then
  // reloads.
  const handleRefreshSession = async () => {
    setRefreshing(true);
    try {
      const response = await tokenRenew();
      if (response?.status !== 200) {
        toast.error(response?.message || "Could not refresh your session");
        setRefreshing(false);
        return;
      }

      const authUser = JSON.parse(localStorage.getItem("authUser")) || {};
      authUser.token = response.token || authUser.token;
      // Applied only when present, so a frontend running ahead of the backend
      // half cannot blank the capability list and lock the user out of their
      // own menus.
      if (response.get_securityauthcapability_list) {
        authUser.get_securityauthcapability_list =
          response.get_securityauthcapability_list;
      }
      if (response.get_securityauthrole_list) {
        authUser.get_securityauthrole_list = response.get_securityauthrole_list;
      }
      if (response.get_staff_data) {
        authUser.get_staff_data = response.get_staff_data;
      }
      localStorage.setItem("authUser", JSON.stringify(authUser));

      toast.success("Session refreshed — reloading");
      // The sidebar and every Gate read authUser at mount, so a reload is the
      // honest way to apply it everywhere at once.
      setTimeout(() => window.location.reload(), 600);
    } catch (e) {
      toast.error("Could not refresh your session");
      setRefreshing(false);
    }
  };

  return (
    <SettingsPanel
      title="Debug"
      description="Build version and diagnostic information."
    >
      <div className={"p-2"}>
        <div className=" ">
          {" "}
          <span className={""}>Version No: </span>
          <span>{version}</span>
        </div>
        <div>Build Tag: {buildTag}</div>
        <div>Build Date/Time: {buildDate}</div>
        <div>User Email: {localStorageInfo} </div>
        <hr />
        <div className={"pt-2"}>
          <button
            className={"btn btn-primary me-2"}
            disabled={refreshing}
            onClick={handleRefreshSession}
          >
            {refreshing ? "Refreshing…" : "Refresh my permissions & menu"}
          </button>
          <button
            className={"btn btn-outline-secondary"}
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload page
          </button>
        </div>
        <small className="text-muted d-block pt-2">
          Use <strong>Refresh my permissions &amp; menu</strong> after someone
          changes your security role or your navigation menu — those are stored
          when you log in, so a plain page reload will not pick them up.
        </small>
      </div>
    </SettingsPanel>
  );
}
